export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:3001';
export const DETECTOR_URL = import.meta.env.VITE_DETECTOR_URL || 'http://localhost:5000';
